var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ph_layout_nav_lay"},[(_vm.isHeaderMenuVisible)?_c('Head',{class:_vm.headerMenuExpanded ? '' : 'hidden'}):_vm._e(),_vm._v(" "),_c('navigation',[_c('router-view')],1),_vm._v(" "),(_vm.isFixedBarVisible)?_c('BackToMoon'):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cd587cf4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/layouts/NavLay.vue
// module id = null
// module chunks = 